import styled from "styled-components";

  
export  const ModalContent = styled.div`
    text-align: center;
    padding: 20px 0;
    font-family: 'Roboto';
  `;
  
export  const ModalTitle = styled.h2`
    margin: 0 0 16px 0;
    font-size: 20px;
    font-weight: 600;
    color: #333;
  `;
  
export  const ModalMessage = styled.p`
    margin: 0 0 24px 0;
    font-size: 16px;
    line-height: 1.5;
    color: #666;
  `;
  
export  const ButtonContainer = styled.div`
    display: flex;
    gap: 30px;
    justify-content: center;
    flex-wrap: wrap;
  `;
  